/* eslint-disable */
import * as Msal from '@azure/msal-browser'
import messageConstant from 'constants/messageConstant'
import { store } from '../index'

const b2cPolicies = {
  names: {
    signUpSignIn: `${process.env.REACT_APP_AZURE_AD_B2C_SIGNIN_FLOW}`,
    forgotPassword: `${process.env.REACT_APP_AZURE_AD_B2C_PASSWORD_RESET_FLOW}`,
    editProfile: `${process.env.REACT_APP_AZURE_AD_B2C_EDIT_PROFILE_FLOW}`,
  },
  authorities: {
    signUpSignIn: {
      authority: `${process.env.REACT_APP_AZURE_AD_B2C_AUTHORITY_BASE_URL}${process.env.REACT_APP_AZURE_AD_B2C_SIGNIN_FLOW}`,
    },
    forgotPassword: {
      authority: `${process.env.REACT_APP_AZURE_AD_B2C_AUTHORITY_BASE_URL}${process.env.REACT_APP_AZURE_AD_B2C_PASSWORD_RESET_FLOW}`,
    },
    editProfile: {
      authority: `${process.env.REACT_APP_AZURE_AD_B2C_AUTHORITY_BASE_URL}${process.env.REACT_APP_AZURE_AD_B2C_EDIT_PROFILE_FLOW}`,
    },
  },
  authorityDomain: `${process.env.REACT_APP_AZURE_AD_B2C_AUTHORITY_DOMAIN}`,
}

const msalConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_AZURE_AD_B2C_CLIENTID}`, // This is the ONLY mandatory field; everything else is optional.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose sign-up/sign-in user-flow as your default.
    knownAuthorities: [b2cPolicies.authorityDomain], // You must identify your tenant's domain as a known authority.
    redirectUri: `${process.env.REACT_APP_UI_URL}`, // You must register this URI on Azure Portal/App Registration. Defaults to "window.location.href".
    postLogoutRedirectUri: `${process.env.REACT_APP_UI_URL}/authorize/callback`,
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO.
    storeAuthStateInCookie: false, // If you wish to store cache items in cookies as well as browser cache, set this to "true".
  },
}

const loginRequest = {
  scopes: [`openid ${process.env.REACT_APP_AZURE_AD_B2C_SCOPE}`],
}

export const tokenRequest = {
  scopes: [`${process.env.REACT_APP_AZURE_AD_B2C_SCOPE}`],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
}
const myMSALObj = new Msal.PublicClientApplication(msalConfig)

var accountId = localStorage.getItem('accountId') || ''
var username = ''
let history = null

export function initializeHistory(historyParam) {
  history = historyParam
}

myMSALObj
  .handleRedirectPromise()
  .then(handleResponse)
  .catch(error => {
    console.error(error)

    if (error && error.errorMessage && error.errorMessage.indexOf('AADB2C90118') > -1) {
      try {
        myMSALObj.loginRedirect(b2cPolicies.authorities.forgotPassword)
      } catch (err) {
        console.error(err)
      }
    } else if (error && error.errorMessage && error.errorMessage.indexOf('AADB2C90091') > -1) {
      //AADB2C90091: The user has cancelled entering self-asserted information.
      try {
        myMSALObj.loginRedirect(b2cPolicies.authorities.signUpSignIn)
      } catch (err) {
        console.error(err)
      }
    }
  })

function selectAccount() {
  const currentAccounts = myMSALObj.getAllAccounts()
  if (!currentAccounts || currentAccounts.length < 1) {
    return
  } else if (currentAccounts.length > 1) {
    const accounts = currentAccounts.filter(
      account =>
        account.homeAccountId
          .toUpperCase()
          .includes(b2cPolicies.names.signUpSignIn.toUpperCase()) &&
        account.idTokenClaims.iss
          .toUpperCase()
          .includes(b2cPolicies.authorityDomain.toUpperCase()) &&
        account.idTokenClaims.aud === msalConfig.auth.clientId,
    )
    if (accounts.length > 1) {
      if (accounts.every(account => account.localAccountId === accounts[0].localAccountId)) {
        localStorage.setItem('accountId', accounts[0].homeAccountId)
        accountId = accounts[0].homeAccountId
        username = accounts[0].username
        store.dispatch({
          type: 'user/GETUSERNAME',
          payload: {
            name: accounts[0].username,
            authenticated: true,
          },
        })
        localStorage.setItem('username', JSON.stringify(accounts[0].username))
      } else {
        currentAccounts.forEach(obj => {
          localStorage.removeItem('username')
          store.dispatch({
            type: 'user/GETUSERNAME',
            payload: {
              name: null,
              authenticated: false,
            },
          })
          const logoutRequest = {
            account: myMSALObj.getAccountByHomeId(obj.homeAccountId),
          }
          if (logoutRequest.account != null) {
            myMSALObj.logout(logoutRequest)
          } else {
            signIn()
          }
        })
      }
    } else if (accounts.length === 1) {
      localStorage.setItem('accountId', accounts[0].homeAccountId)
      accountId = accounts[0].homeAccountId
      username = accounts[0].username
      store.dispatch({
        type: 'user/GETUSERNAME',
        payload: {
          name: accounts[0].username,
          authenticated: true,
        },
      })
      localStorage.setItem('username', JSON.stringify(accounts[0].username))
    }
  } else if (currentAccounts.length === 1) {
    localStorage.setItem('accountId', currentAccounts[0].homeAccountId)
    accountId = currentAccounts[0].homeAccountId
    username = currentAccounts[0].username
    store.dispatch({
      type: 'user/GETUSERNAME',
      payload: {
        name: localStorage.getItem('username'),
        authenticated: true,
      },
    })
  }
}

function handleResponse(response) {
  if (response && response.idTokenClaims) {
    localStorage.setItem('username', response.idTokenClaims.given_name)
  }
  if (response !== null) {
    if (response.idTokenClaims['acr'] === b2cPolicies.names.forgotPassword) {
      window.alert(messageConstant.User.ForgotPasswordSuccessResponse)

      // Choose which account to logout from by passing a username.
      const logoutRequest = {
        account: myMSALObj.getAccountByHomeId(accountId),
      }

      myMSALObj.logout(logoutRequest)
    } else if (response.idTokenClaims['acr'] === b2cPolicies.names.editProfile) {
      window.alert(messageConstant.User.ProfileUpdateSuccessResponse)
    } else {
      selectAccount()
      handleRedirect()
    }
  } else {
    const currentAccounts = myMSALObj.getAllAccounts()
    if (currentAccounts.length === 0) {
      // no accounts signed-in, attempt to sign a user in
      myMSALObj.loginRedirect(loginRequest)
    } else {
      selectAccount()
    }
  }
}

//myMSALObj.handleRedirectPromise().then(handleResponse);

function handleRedirect() {
  if (!history) {
    window.location.reload()
    console.error('History object is not initialized. Call initializeHistory before redirecting.')
    return
  }
  getTokenRedirect(tokenRequest).then(response => {
    if (!response || !response.accessToken) {
      localStorage.removeItem('IsUserAuthorized')
      signIn()
    } else {
      history.push('/dashboard')
    }
  })
}

export function signIn() {
  //await myMSALObj.handleRedirectPromise()
  myMSALObj.loginRedirect(loginRequest)
}

export function signOut() {
  localStorage.removeItem('accountId')
  localStorage.removeItem('username')
  localStorage.removeItem('logoutUser')
  localStorage.removeItem('IsUserAuthorized')
  store.dispatch({
    type: 'user/GETUSERNAME',
    payload: {
      name: null,
      authenticated: false,
    },
  })
  selectAccount()
  // Choose which account to logout from by passing a username.
  const logoutRequest = {
    account: myMSALObj.getAccountByHomeId(accountId),
  }

  if (logoutRequest.account != null) {
    myMSALObj.logout(logoutRequest)
  } else {
    signIn()
  }
}
export function getTokenRedirect(request) {
  request.account = myMSALObj.getAccountByHomeId(accountId)
  return myMSALObj.acquireTokenSilent(request).catch(error => {
    console.warn(error)
    console.warn(messageConstant.User.SilentTokenAcquisitionFailed)
    if (error instanceof Msal.InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      return myMSALObj.acquireTokenRedirect(request)
    } else {
      console.warn(error)
    }
  })
}

// Acquires and access token and then passes it to the API call
export function passTokenToApi() {
  getTokenRedirect(tokenRequest)
  if (accessToken) {
    try {
      callApi(apiConfig.webApi, accessToken)
    } catch (error) {
      console.warn(error)
    }
  }
}

export function editProfile() {
  myMSALObj.loginRedirect(b2cPolicies.authorities.editProfile)
}

export function changePassword() {
  localStorage.setItem('logoutUser', true)
  myMSALObj.loginRedirect(b2cPolicies.authorities.forgotPassword)
}
